// @flow
import client from '../../client'

// API Endpoint
export const TRACK_SEARCH = '/tracking/search_time/'

/**
 * Track search quality measures
 * @param  {Object} data Search traking information
 * @param  {string} data.search_id Id of the search (session_id)
 * @param  {number} data.load_time The page load time in seconds
 * @param  {number} data.poll_time Poll load time in seconds
 * @return {Promise|Error} A resolved Promise with pushed tracking information
 */
export const trackSearchQuality = (data: {
  search_id: string,
  load_time: number,
  poll_time: number,
}): Promise<any> => client.post(TRACK_SEARCH, { body: data })

export default trackSearchQuality
